module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.legendUrls), function(legendUrl, index) {
    return _c('div', {
      key: ("legendUrl-" + index)
    }, [_c('img', {
      attrs: {
        "src": legendUrl
      }
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-709ed855","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContextLegend.vue
// module id = 620
// module chunks = 2